import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-qty-label',
  templateUrl: './qty-label.component.html',
  styleUrls: ['./qty-label.component.sass'],
})
export class QtyLabelComponent {
  @Input() number = 0;
  @Input() size = '17px';
  @Input() background = 'red';
  @Input() color = 'white';
}
